

<template>
  <div class="filtercollection">
    <div class="fchead">
      <span class="fcheadlabel">{{ title }}</span>
      <span class="pull-right kruisje hidden-md hidden-lg" v-on:click="$emit('showfiltercol')">
        <i class="fa fa-times fcheadlabel" aria-hidden="true"></i>
      </span>
    </div>
    <!-- <div class="fctags filtertags">
            <ul id="filtertags" style="display: inline;">
                <li v-for="filter in this.$store.getters.getFilters" class="tags" data-xau-filtername="datumfilter"><span>{{filter.text}}</span><i  v-on:click="deleteFilter(filter)" class="fa fa-times tagsclose"></i></li>                 
            </ul>
    </div>-->
    <div class="filtercol row">
      <div class="col-lg-12">
        <slot></slot>
        <div class="form-group">
          <button class="btn-block btn btn-primary" v-on:click="$emit('showfiltercol')">
            {{ $store.state.translation[13741] }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template> 

<script>
'use strict'
import { EventBus } from 'pevueglobal'
export default {
  props: {
    enabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      Ienabled: this.enabled,
      filters: [],
    }
  },
  methods: {
    deleteFilter: function (myfilter) {
      this.$store.commit('deleteFilter', myfilter.name)
      EventBus.$emit('FilterDeleted', myfilter)
      this.filters = this.$store.getters.getFilters
    },
  },
  mounted: function () {
    this.filters = this.$store.getters.getFilters
  },
}
</script>

<!--,
            ...mapGetters({
                filters: 'getFilters'
            })--> 
